<template>
	<label
		class="col radio-container radio-container--growth align-items-center justify-content-center d-flex text-center"
		:class="{ 'active': checked }"
	>
		{{ label }}
		<input
			type="radio"
			:required="required ?? undefined"
			:name="name"
			:value="value"
			:checked="checked ?? undefined"
			@input="$emit('input', value)"
			@change="$emit('change', value)"
		/>
		<span class="radiobtn" />
	</label>
</template>

<script setup>
import { required } from '@vuelidate/validators';

defineProps({
	name: String,
	value: String,
	label: String,
	required: Boolean,
	selected: Boolean,
	checked: Boolean
});

defineEmits([
	'input',
	'change'
]);

</script>
